import axios from 'axios';

// Use REACT_APP_BACKEND_URL for preview, but use relative URLs on custom domains
// so API calls go through the same domain's ingress
const CONFIGURED_URL = process.env.REACT_APP_BACKEND_URL || '';
const isCustomDomain = typeof window !== 'undefined' && 
  CONFIGURED_URL && 
  !window.location.origin.includes('preview.emergentagent.com') &&
  !window.location.origin.includes('localhost');
const API_URL = isCustomDomain ? '' : CONFIGURED_URL;

const api = axios.create({
  baseURL: API_URL,
});

// Request interceptor to add auth token (only if not already set by caller)
api.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      const token = localStorage.getItem('session_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('session_token');
    }
    return Promise.reject(error);
  }
);

export default api;
